const DROPDOWN_TYPE = {
  SINGLE_DROPDOWN: 'single_dropdown',
  DROPDOWN: 'dropdown',
  AUTOCOMPLETE: 'autocomplete'
};

export { DROPDOWN_TYPE };
